<template>
  <div class="headline">
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "headline-view",
  props: {
    title: String,
  },
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.headline {
  width: 100%;
  height: 100%;
	display: flex;
	align-items: center;
}
span {
  font-size: 20px;
}
</style>
